
define([], function() {
  return {
    get: function(id) {
      var obj;
      obj = typeof localStorage !== "undefined" && localStorage !== null ? localStorage.getItem(id) : void 0;
      if (obj != null) {
        try {
          return JSON.parse(obj);
        } catch (e) {
          return null;
        }
      } else {
        return null;
      }
    },
    set: function(id, obj) {
      return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.setItem(id, JSON.stringify(obj)) : void 0;
    }
  };
});
